/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, ViewEncapsulation, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class ChangeOrgDownlineConfirmationModalContext {
  // public isFrom: string;
  public data?: any;
}

@Component({
  selector: 'app-change-org-downline-confirmation-modal',
  templateUrl: './change-org-downline-confirmation-modal.component.html',
  styleUrls: ['./change-org-downline-confirmation-modal.component.scss'],
  providers: [CommonService],
  encapsulation: ViewEncapsulation.None
})

export class ChangeOrgDownlineConfirmationModalComponent implements OnInit {
  @Input() context!: ChangeOrgDownlineConfirmationModalContext;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  public param: any;
  public currentOrganization: any;
  public newOrganization: any;
  public newDownlineOrganization: any;
  public currentClientID = '';
  public genTypes: any = {};
  public savedReports: any[] = [];
  details: any;

  constructor(
    public bsModalRef: BsModalRef<ChangeOrgDownlineConfirmationModalContext>,
    public commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.param = {
      value: this.context.data.orgUnitLbl
    };
    this.currentOrganization = this.context.data.currentOrganization;
    this.newOrganization = this.context.data.newOrganization;
    this.newDownlineOrganization = this.context.data.newDownlineOrganization;
    this.currentClientID = this.context.data.clientID;
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.closeModal.emit('closed');
    this.bsModalRef.hide();
  }

  public confirmChange() {
    this.closeModal.emit('confirmed');
    this.bsModalRef.hide();
  }
}
